import { useEffect, useRef } from "react";
import { Form, useParams, useSubmit } from "react-router-dom";

function EmailVerificationPage() {
  const { confirmationToken } = useParams();
  const submit = useSubmit();
  const hiddenFormRef = useRef<HTMLFormElement | null>(null);
  useEffect(() => {
    submit(hiddenFormRef.current, { method: "POST" });
  }, [submit]);
  return (
    <div className="flex justify-center items-center min-h-[calc(20vh)] gap-4">
      Verifying token
      <span className="loading loading-spinner text-primary w-4 "></span>
      <Form ref={hiddenFormRef}>
        <input
          hidden
          readOnly
          value={confirmationToken}
          name="confirmationToken"
        />
      </Form>
    </div>
  );
}

export default EmailVerificationPage;
